import React, { createContext, useContext, useMemo, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addItem = (photo, eventId) => {
    setItems(prev => {
      if (prev.some(item => item.id === photo.id)) return prev;

      return [
        ...prev,
        {
          id: photo.id,
          eventId,
          name: photo.name || photo.title || photo.filename || `Photo ${photo.id}`,
          filename: photo.filename,
          price: Number(photo.price || 0),
        },
      ];
    });
  };

  const removeItem = (photoId) => {
    setItems(prev => prev.filter(item => item.id !== photoId));
  };

  const toggleItem = (photo, eventId) => {
    setItems(prev => {
      if (prev.some(item => item.id === photo.id)) {
        return prev.filter(item => item.id !== photo.id);
      }

      return [
        ...prev,
        {
          id: photo.id,
          eventId,
          name: photo.name || photo.title || photo.filename || `Photo ${photo.id}`,
          filename: photo.filename,
          price: Number(photo.price || 0),
        },
      ];
    });
  };

  const clearCart = () => setItems([]);

  const value = useMemo(() => ({
    items,
    count: items.length,
    total: items.reduce((sum, item) => sum + Number(item.price || 0), 0),
    addItem,
    removeItem,
    toggleItem,
    clearCart,
  }), [items]);

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart must be used within CartProvider');
  return context;
};
